import React from "react";

import asyncComponent from '../components/AsyncComponent'
import MyOrder from "../containers/my-order";
import Employee from "../containers/employee";
import PackingSlip from "../containers/packing-slip";
import OrderMould from "../containers/order_mould";
import Material from "../containers/material";
import OrderPurchase from "../containers/order-purchase";
import Industry from "../containers/industry";
import CustomPicture from "../containers/custom-picture";
import CompanyConfig from "../containers/company_config";
import ProcessReport from "../containers/proceass-report";
import ProductLocationArea from "../containers/product-location/area";
import ProductPrice from "../containers/product-price";
import Factory from "../containers/factory";
import TemporaryLocationLog from "../containers/temporary-location";

const User = asyncComponent(() => import("../containers/user"));
const Role = asyncComponent(() => import("../containers/role"));
const Menu = asyncComponent(() => import("../containers/menu"));
const Company = asyncComponent(() => import("../containers/company"));
const Unit = asyncComponent(() => import("../containers/unit"));
const Category = asyncComponent(() => import("../containers/category"));
const Machine = asyncComponent(() => import("../containers/machine"));
const Template = asyncComponent(() => import("../containers/template"));
const ProductLocation = asyncComponent(() => import("../containers/product-location"));
const ProductTagLog = asyncComponent(() => import("../containers/product-tag/log"));
const Keyword = asyncComponent(() => import("../containers/keyword"));
const ProcessTemplate = asyncComponent(() => import("../containers/process-template"));
const PDF = asyncComponent(() => import("../containers/pdf"));
const ProductPicture = asyncComponent(() => import("../containers/product-picture"));
const OrderDie = asyncComponent(() => import("../containers/order_die"));
const ProductModel = asyncComponent(() => import("../containers/product-model"));
const ReportOrder = asyncComponent(() => import("../containers/report-order"));
const ProcessGroup = asyncComponent(() => import("../containers/process-group"));
const ProductDrawing = asyncComponent(() => import("../containers/product-drawing"));


const routes = {
    '/admin/menu': {
        component: Menu,
    },
    '/admin/company': {
        component: Company,
    },
    '/admin/industry': {
        component: Industry,
    },
    '/sys/user': {
        component: User,
    },
    '/sys/role': {
        component: Role,
    },
    '/sys/employee': {
        component: Employee,
    },
    '/sys/company/config': {
        component: CompanyConfig
    },
    '/basic/unit': {
        component: Unit
    },
    '/basic/category': {
        component: Category
    },
    '/basic/template': {
        component: Template
    },
    '/basic/keyword': {
        component: Keyword
    },
    '/basic/process/template': {
        component: ProcessTemplate
    },
    '/basic/process/group': {
        component: ProcessGroup
    },
    '/basic/material': {
        component: Material
    },
    '/basic/machine': {
        component: Machine
    },
    '/basic/factory': {
        component: Factory
    },
    '/report/product/location/area': {
        component: ProductLocationArea
    },
    '/report/product/location': {
        component: ProductLocation
    },
    '/report/tag/log': {
        component: ProductTagLog
    },
    '/report/pdf': {
        component: PDF
    },
    '/report/product/picture': {
        component: ProductPicture
    },
    '/report/custom/picture': {
        component: CustomPicture
    },
    '/report/order/die': {
        component: OrderDie
    },
    '/report/order/model': {
        component: ProductModel
    },
    '/report/order/mould': {
        component: OrderMould
    },
    '/report/order': {
        component: ReportOrder
    },
    '/report/product/drawing/0': {
        component: () => (<ProductDrawing type={0}/>)
    },
    '/report/product/drawing/1': {
        component: () => (<ProductDrawing type={1}/>)
    },
    '/report/product/drawing/2': {
        component: () => (<ProductDrawing type={2}/>)
    },
    '/report/product/drawing/3': {
        component: () => (<ProductDrawing type={3}/>)
    },
    '/report/my': {
        component: MyOrder
    },
    '/report/packing': {
        component: PackingSlip
    },
    '/report/purchase': {
        component: OrderPurchase
    },
    '/report/process/report': {
        component: ProcessReport
    },
    '/report/price': {
        component: ProductPrice
    },
    '/report/temporary/location/log': {
        component: TemporaryLocationLog
    },
};

export default routes
